export default __webpack_public_path__ + "static/media/04.19a586a7.png";